
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Base } from '@/interfaces/Base'
import InfiniteLoading from 'vue-infinite-loading'
import { GroupTag } from '@/interfaces/GroupTag'
import { Group } from '@/interfaces/Group'
import ProductSelector from '@/components/ProductSelector.vue'
import { ProductDetail } from '@/models/ProductDetail'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  components: {
    ProductSelector,
    InfiniteLoading
  }
})
export default class Step2 extends Vue {
  private bases: Base[] = [];

  private offset = 0
  private limit = 12

  get filter (): Group | GroupTag {
    return this.$store.state.tag ? this.$store.state.tag : this.$store.state.group
  }

  async infiniteHandler ($state: any) {
    if (this.offset === 0) {
      this.bases = []
    }

    const newData = await this.$apiService.getBases(this.filter, this.offset, this.limit)

    if (newData != null) {
      this.bases = this.bases?.concat(newData)

      if (newData.length < this.limit) {
        $state.complete()
      } else {
        this.offset += this.limit
        $state.loaded()
      }
    } else {
      $state.complete()
    }
  }

  onProductClick (product: ProductDetail) {
    this.$store.commit(MutationTypes.CHANGE_CURRENT_STEP, { currentStep: 2, baseProductId: product.id })
  }
}
